import { useEffect, useState, useMemo, } from 'react';

import Container from '@material-ui/core/Container';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import AddCircleOutlinedIcon from '@material-ui/icons/AddCircleOutlined';

import './styles.css'

import ToastAnimated, { showToast, } from '../../ui-lib/toast';
import 'react-toastify/dist/ReactToastify.css';

import NavBar from '../../components/NavBar/NavBar';
import ServersTable from '../../components/ServersTable';
import ServerForm from '../../components/ServerForm';
import Dialog from '../../components/Dialog';

import {
  createCompanyServer,
  listCompanyServers,
  deleteCompanyServer,
  updateCompanyServer,
} from '../../services/api';

import useModal from '../../hooks/useModal';


function CompanyServers() {
  const idEmpresa = localStorage.getItem('idEmpresa');
  const name_empresa = localStorage.getItem('name_empresa');

  const [servers, setServers] = useState([]);
  const [loading, setLoading] = useState(false);

  const hostFormModal = useModal((serverId) => setSelectedHostId(serverId),
    () => setSelectedHostId(undefined));
  const [selectedHostId, setSelectedHostId] = useState(undefined);
  const selectedHost = useMemo(() => servers.find(({ _id, }) => _id === selectedHostId),
    [servers, selectedHostId]);


  async function getData() {
    try {
      const { data, } = await listCompanyServers(idEmpresa);
      setServers(data);
    } catch (error) {
      //TODO: handle error
    }
  }

  useEffect(() => {
    getData();
  }, []);

  function onCreateServer({ name, }) {
    createCompanyServer(idEmpresa, name)
      .then(() => {
        showToast({
          type: 'success',
          message: 'Host criado com sucesso!',
        });
        hostFormModal.onClose();
        getData();
      })
      .catch(({ data }) => {
        console.log(data);
        showToast({
          type: 'error',
          message: 'Erro ao criar ao criar host',
        });
      })
      .finally(() => {
        setLoading(false);
      });
  }

  async function onUpdateServer({ companyId, name, serverId, }) {
    try {
      const { data: updatedServer, } = await updateCompanyServer(companyId, serverId, name);
      showToast({
        type: 'success',
        message: 'Host atualizado com sucesso!',
      });
      hostFormModal.onClose();
      const updatedServers = [...servers];
      const serverIdx = updatedServers.findIndex(({ _id, }) => _id === serverId);
      if (serverIdx > -1) {
        updatedServers[serverIdx] = updatedServer;
      }
      setServers(updatedServers);
    } catch (error) {
      console.log(error);
      return showToast({
        type: 'error',
        message: 'Erro ao criar ao atualizar host!',
      });
    } finally {
      setLoading(false);
    }
  }

  function onSubmitServer({ name, }) {
    if (loading) {
      return;
    }

    setLoading(true);

    if (undefined != selectedHost) {
      onUpdateServer({
        name,
        companyId: selectedHost.idEmpresa,
        serverId: selectedHost._id,
      });
    } else {
      onCreateServer({
        name,
      });
    }
  }

  async function onDeleteServer(companyId, serverId) {
    try {
      await deleteCompanyServer(companyId, serverId);
      showToast({
        type: 'success',
        message: 'Host excluído com sucesso!',
      });
      setServers(servers.filter(({ _id, }) => serverId != _id));
    } catch (error) {
      console.log(error);
      return showToast({
        type: 'error',
        message: 'Erro ao criar ao excluir host!',
      });
    }
  }


  return (
    <NavBar>
      <ToastAnimated />

      <Container
        component={Paper}
        style={{
          padding: '1rem',
        }}
      >
        <Typography
          display="block"
          align="center"
          variant="h5"
          style={{
            fontWeight: 'bold',
            margin: '1rem 0',
          }}
        >
          Hosts da empresa {name_empresa}
        </Typography>

        <div
          style={{
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            justifyContent: 'flex-end',
          }}
        >
          <Button
            onClick={hostFormModal.onOpen}
            size="small"
            variant="contained"
            disableElevation
            startIcon={<AddCircleOutlinedIcon />}
            color="primary"
            style={{
              margin: '1rem 0',
              textTransform: 'none',
            }}
          >
            Cadastrar Host
          </Button>
        </div>

        <ServersTable
          servers={servers}
          onEdit={hostFormModal.onOpen}
          onDelete={onDeleteServer}
        />

        <Dialog
          open={hostFormModal.value}
          onClose={hostFormModal.onClose}
          title="Configurar host"
        >
          <ServerForm
            data={undefined != selectedHost ? { name: selectedHost.host } : undefined}
            loading={loading}
            onSubmit={onSubmitServer}
          />
        </Dialog>
      </Container>
    </NavBar>
  );
}

export default CompanyServers;
